
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subscribe/[slug]",
      function () {
        return require("private-next-pages/subscribe/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/subscribe/[slug]"])
      });
    }
  